import { ExpandMore } from "@material-ui/icons";
import classNames from "classnames";
import { useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import { env } from "../../../env";
import { Title } from "../../styled";
import ListItem from "./listItem";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Menu,
	Scrollbar
} from "./styled";

const MenuConfig = (props) => {
	const location = useLocation();
	const ListRef = useRef(null);
	const [searchValue, setSearchValue] = useState("");
	let { pathname } = location;
	const { t } = props;
	pathname = `/${pathname
		.split("/")
		.filter((x) => x.length > 0)
		.join("/")}`;

	const slugify = (str) => {
		if (!str) {
			return "";
		}
		let letters = {
			"-": "",
			a: "á|à|ã|â|À|Á|Ã|Â",
			e: "é|è|ê|É|È|Ê",
			i: "í|ì|î|Í|Ì|Î",
			o: "ó|ò|ô|õ|Ó|Ò|Ô|Õ",
			u: "ú|ù|û|ü|Ú|Ù|Û|Ü",
			c: "ç|Ç",
			n: "ñ|Ñ",
		};

		for (let pattern in letters) {
			str = str && str.replace(new RegExp(letters[pattern], "g"), pattern);
		}

		return str.toLowerCase();
	};

	/* const SearchItemMenu = (search) => {
		[...ListRef.current.querySelectorAll("li")].map((el) => {
			if (
				search.length === 0 ||
				slugify(el.querySelector("a > span").innerText).includes(
					slugify(search)
				)
			) {
				el.classList.remove("hidden");
			} else {
				el.classList.add("hidden");
			}
		});
	}; */

	/*   useEffect(() => {
		SearchItemMenu(searchValue);
	}, [searchValue]); */

	return (
		<Menu className={classNames({ active: pathname !== "/configuracoes" })}>
			<Title>{t.title}</Title>
			{/* <OutlinedInput
        placeholder="Pesquisar"
        type="search"
        onChange={({ target }) => setSearchValue(target.value)}
        value={searchValue}
        startAdornment={
          <InputAdornment
            onClick={() => {
              SearchItemMenu(searchValue);
            }}
          >
            <SearchIcon />
          </InputAdornment>
        }
      /> */}
			<Scrollbar>
				<Accordion defaultExpanded={true}>
					<AccordionSummary expandIcon={<ExpandMore />}>
						<h4>{t.system}</h4>
					</AccordionSummary>
					<AccordionDetails>
						{env.REACT_APP_NEW_CRM === "true" && (
							<ListItem
								to="/configuracoes/database"
								className={classNames("system", {
									active: pathname === "/configuracoes/database",
								})}
							>
								<span>Base de dados</span>
							</ListItem>
						)}
						{env.REACT_APP_NEW_CRM === "true" && (
							<ListItem
								to="/configuracoes/open-reason"
								className={classNames("system", {
									active: pathname === "/configuracoes/open-reason",
								})}
							>
								<span>Motivo de abertura de ticket</span>
							</ListItem>
						)}
						<ListItem
							to="/configuracoes/departamento"
							className={classNames("system", {
								active: pathname === "/configuracoes/departamento",
							})}
						>
							{/*Controle de &nbsp;*/}
							<span>{t.department}</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/distribuicao"
							className={classNames("system", {
								active: pathname === "/configuracoes/distribuicao",
							})}
						>
							Controle de &nbsp;<span>Distribuição</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/sla"
							className={classNames("system", {
								active: pathname === "/configuracoes/sla",
							})}
						>
							Controle de &nbsp;<span>SLA</span>
						</ListItem>
						<ListItem
							to="/configuracoes/horario"
							className={classNames("system", {
								active: pathname === "/configuracoes/horario",
							})}
						>
							<span>{t.officeHours}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/mensagem-inatividade"
							className={classNames("system", {
								active: pathname === "/configuracoes/mensagem-inatividade",
							})}
						>
							<span>Mensagem de inatividade</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/palavra_bloqueada"
							className={classNames("system", {
								active: pathname === "/configuracoes/palavra_bloqueada",
							})}
						>
							<span>{t.profanity}</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/pausar-protocolo"
							className={classNames("system", {
								active: pathname === "/configuracoes/pausar-protocolo",
							})}
						>
							{/*Configurações do &nbsp;*/}
							<span>Pausar protocolo</span>
						</ListItem>
						<ListItem
							to="/configuracoes/pausas"
							className={classNames("system", {
								active: pathname === "/configuracoes/pausas",
							})}
						>
							{/*Configurações do &nbsp;*/}
							<span>{t.breaks}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/tabulacoes"
							className={classNames("system", {
								active: pathname === "/configuracoes/tabulacoes",
							})}
						>
							<span>{t.tab}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/usuario"
							className={classNames("system", {
								active: pathname === "/configuracoes/usuario",
							})}
						>
							{/*Controle de &nbsp;*/}
							<span>{t.user}</span>
						</ListItem>
					</AccordionDetails>
				</Accordion>

				<Accordion defaultExpanded={true}>
					<AccordionSummary expandIcon={<ExpandMore />}>
						<h4>{t.business}</h4>
					</AccordionSummary>
					<AccordionDetails>
						<ListItem
							to="/configuracoes/bot-ben"
							className={classNames("business", {
								active: pathname === "/configuracoes/create-ben",
							})}
						>
							<span>Bot&nbsp;</span> - Ben
						</ListItem>
						<ListItem
							to="/configuracoes/inteligencia"
							className={classNames("business", {
								active: pathname === "/configuracoes/inteligencia",
							})}
						>
							<span>Bot&nbsp;</span> - {t.intelligence}
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/discador"
							className={classNames("business", {
								active: pathname === "/configuracoes/discador",
							})}
						>
							<span>{t.dialer}</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/email"
							className={classNames("business", {
								active: pathname === "/configuracoes/email",
							})}
						>
							<span>{t.email}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/email-marketing"
							className={classNames("business", {
								active: pathname === "/configuracoes/email-marketing",
							})}
						>
							<span>{t.emailMarketing}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/email-imap"
							className={classNames("business", {
								active: pathname === "/configuracoes/email-imap",
							})}
						>
							<span>{t.emailIMap}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/faq"
							className={classNames("business", {
								active: pathname === "/configuracoes/faq",
							})}
						>
							<span>{t.faq}</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/google-chat"
							className={classNames("business", {
								active: pathname === "/configuracoes/google-chat",
							})}
						>
							<span>Google chat</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/instagram"
							className={classNames("business", {
								active: pathname === "/configuracoes/instagram",
							})}
						>
							<span>{t.instagram}</span>
						</ListItem>

						<ListItem
							to="/configuracoes/landing-page"
							className={classNames("business", {
								active: pathname === "/configuracoes/landing-page",
							})}
						>
							<span>Landing Page</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/role-function"
							className={classNames("business", {
								active: pathname === "/configuracoes/role-function",
							})}
						>
							<span>Permissão de funções</span>
						</ListItem>
						{(env.REACT_APP_API_URL === "https://api-hmv.digitalk.com.br" ||
							env.REACT_APP_API_URL ===
							"https://api-hmv-homol.digitalk.com.br") && (
								<ListItem
									to="/configuracoes/privilegios"
									className={classNames("business", {
										active: pathname === "/configuracoes/privilegios",
									})}
								>
									<span>Privilégios</span>
								</ListItem>
							)}
						<ListItem
							to="/configuracoes/net-promoter-score"
							className={classNames("business", {
								active: pathname === "/configuracoes/net-promoter-score",
							})}
						>
							<span>{t.netPromoterScore}</span>
						</ListItem>
						<ListItem
							show={env.REACT_APP_NEW_WORKFLOW !== "true"}
							to="/configuracoes/slack"
							className={classNames("business", {
								active: pathname === "/configuracoes/slack",
							})}
						>
							<span>{t.slack}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/sms"
							className={classNames("business", {
								active: pathname === "/configuracoes/sms",
							})}
						>
							<span>{t.sms}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/tag"
							className={classNames("business", {
								active: pathname === "/configuracoes/tag",
							})}
						>
							<span>Tags&nbsp;</span>
						</ListItem>
						<ListItem
							to="/configuracoes/whatsapp"
							className={classNames("business", {
								active: pathname === "/configuracoes/whatsapp",
							})}
						>
							<span>{t.whatsapp}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/widget"
							className={classNames("business", {
								active: pathname === "/configuracoes/widget",
							})}
						>
							<span>{t.widget}</span>
						</ListItem>
						<ListItem
							to="/configuracoes/widget-inbot"
							className={classNames("business", {
								active: pathname === "/configuracoes/widget-inbot",
							})}
						>
							<span>{t.widget} Inbot</span>
						</ListItem>
					</AccordionDetails>
				</Accordion>
			</Scrollbar>
		</Menu>
	);
};

const mapStateToProps = (state) => ({
	pathname: state.router.location.pathname,
	auth: state.auth,
	t: state.i18nState.translations[state.i18nState.lang]["Settings"]["Menu"],
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MenuConfig);
